module.exports = __webpack_public_path__ + "86dfb651cdd0722c73d543e112e9e935.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/preview.png
// module id = 708
// module chunks = 0